import React, { useEffect, useState } from "react";
import DataTable from "../Common/DataTable";
import {
  Button,
  Space,
  Modal,
  Upload,
  Typography,
  Col,
  Row,
} from "antd";

import {
  UploadOutlined,
  InboxOutlined,
  DeleteFilled,
} from "@ant-design/icons";
import { useAxios } from "../../hooks/useAxios";
import { useNotification } from "../../contexts/NotificationProvider";
import { useParams } from "react-router-dom";
import ViewIcon from "../../assets/svgs/view_icon.svg";
import PDFIcon from "../../assets/svgs/pdf-icon.svg";
import SearchInput from "../FormFields/SearchInput";
import useDeleteConfirm from "../../hooks/useDeleteConfirm";
const { Dragger } = Upload;
const RotasTableView = () => {
  const { axiosInstance } = useAxios();
  const notify = useNotification();
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [rotas, setRotas] = useState([]);
  const [file, setFile] = useState([]);
  const [loading, setLoading] = useState(false);

  const uploaderProps = {
    fileList: file,
    onRemove: (prevFile) => {
      const index = file.indexOf(prevFile);
      const newFileList = file.slice();
      newFileList.splice(index, 1);
      setFile(newFileList);
    },
    beforeUpload: (selectedFile) => {
      const isCsvOrXlsx = /\.(csv|xlsx)$/i.test(selectedFile.name);

      if (!isCsvOrXlsx) {
        notify({
          type: "error",
          message: "Invalid File Type",
          description: "Please upload a CSV or XLSX file.",
        });
        setFile([]);
      } else {
        setFile([selectedFile]);
      }
      return false;
    },
  };
  // const handleView = (record) => {
  //   if (record?.pdf_url) {
  //     // Open the PDF in a new tab
  //     window.open(record.pdf_url, "_blank");
  //   } else {
  //     console.log("No PDF file found");
  //   }
  // };

  const handleDownloadPDF = async (record) => {
    try {
      const response = await axiosInstance.get(
        `/api/rota/generate-pdf/${record.id}/`
      );
      window.open(response.data.pdf_url, "_blank");
    } catch (err) {
      console.error("Error generating PDF", err);
    }
  };
  // const showBulkDeleteConfirm = useDeleteConfirm(async (selectedIds) => {
  //   if (!selectedIds.length) return;
  //   setLoading(true);
  //   try {
  //     await axiosInstance.delete(`/api/rota/list/delete/?week_id=${id}`, {
  //       data: { ids: selectedIds }, // ✅ Sending data in DELETE request
  //     });
  //     notify({ type: "success", message: "Selected rotas deleted" });
  //     fetchRotas();
  //   } catch (error) {
  //     notify({ type: "error", message: "Failed to delete selected rota" });
  //   } finally {
  //     setLoading(false);
  //   }
  // });
  const showBulkDeleteConfirm = useDeleteConfirm(async (selectedIds) => {
    setLoading(true);
    try {
      const payload = {
        ids: selectedIds?.length ? selectedIds : null,
      };
      await axiosInstance.delete(`/api/rota/list/delete/?week_id=${id}`, {
        data: payload,
      });
      notify({
        type: "success",
        message: selectedIds?.length
          ? `Deleted ${selectedIds.length} rotas`
          : "Deleted all rotas",
      });
      fetchRotas();
    } catch (error) {
      notify({
        type: "error",
        message:
          error.response?.data?.message || "Failed to delete selected rotas",
      });
    } finally {
      setLoading(false);
    }
  });
  const columns = [
    {
      title: "Employee ID",
      render: (data) => (
        <span>
          {data.employer}
          {data?.employee?.employee_code}
        </span>
      ), // Adjust to include avatars if needed
    },
    {
      title: "Full Name",
      render: (data) => (
        <span>
          {data?.employee?.last_name} {data?.employee?.first_name}
        </span>
      ), // Adjust to include avatars if needed
    },
    {
      title: "Week Commencing",
      dataIndex: "week_commencing",
      key: "week_commencing",
    },
    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
    },
    {
      title: "Total Hours (Week)",
      render: (data) => <span>{data?.total_hours} HRS</span>, // Adjust to include avatars if needed
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Space size={12}>
          <Button
            icon={
              <img
                src={ViewIcon}
                alt="View Icon"
                style={{ width: 24, height: 24 }}
              />
            }
            onClick={() => handleDownloadPDF(record)}
            style={{
              border: "none",
              background: "none",
              padding: 0,
            }}
          />

          <Button
            icon={
              <img
                src={PDFIcon}
                alt="PDF Icon"
                style={{ width: 24, height: 24 }}
              />
            }
            onClick={() => handleDownloadPDF(record)}
            style={{
              border: "none",
              background: "none",
              padding: 0,
            }}
          />

          <Button
            icon={<DeleteFilled style={{ color: "red", fontSize: 24 }} />}
            onClick={() =>
              showBulkDeleteConfirm(
                [record.id],
                "This action will permanently delete the selected rota. Once deleted, this data cannot be recovered."
              )
            }
            style={{ border: "none", background: "none", padding: 0 }}
          />
        </Space>
      ),
    },

    // {
    //   title: "Remaining Hours (Week) ",
    //   dataIndex: "remainingHrs",
    //   key: "remainingHrs",
    // },
  ];

  const showModal = () => {
    setFile([]);
    setIsModalOpen(true);
  };

  const handleUploadCSV = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file[0]);
    formData.append("week_id", id);
    try {
      const response = await axiosInstance.post("/api/rota/upload/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      notify({
        type: "success",
        message: response.data?.success,
      });
      await fetchRotas();
    } catch (e) {
      console.error("Error Uploading File", e.success);
    } finally {
      setLoading(false);
      setFile([]);
      setIsModalOpen(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const fetchRotas = async (searchTerm = "", page = 1) => {
    try {
      const params = { week_id: id, page }; // Always include week_id

      if (searchTerm) {
        params.search = searchTerm; // Only add search if it's not empty
      }

      const response = await axiosInstance.get("/api/rota/list/", { params });
      setRotas(response.data);
    } catch (e) {
      console.log("Error fetching Rotas", e.message);
    }
  };
  const handleSearch = (value) => {
    setCurrentPage(1);
    setSearchTerm(value);
    fetchRotas(value, 1);
  };
  useEffect(() => {
    fetchRotas();
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    fetchRotas(searchTerm, currentPage);
  }, [searchTerm, currentPage]);
  return (
    <>
      <Modal
        title="Upload CSV"
        open={isModalOpen}
        onCancel={handleCancel}
        wrapClassName="main-modal-class"
        footer={[
          <Button
            style={{
              backgroundColor: "transparent",
              color: "#324054",
              border: "none",
              borderRadius: "4px",
              padding: "0 16px",
              height: "40px",
              fontWeight: 600,
              width: "118px",
            }}
            variant="text"
            onClick={handleCancel}
          >
            Cancel
          </Button>,
          <Button
            style={{
              backgroundColor: file.length ? "#212180" : "#B0B0B0",
              color: file.length ? "#FFF" : "#8C8C8C",
              border: "none",
              borderRadius: "4px",
              padding: "0 16px",
              height: "40px",
              fontWeight: 600,
              width: "118px",
            }}
            variant="text"
            onClick={handleUploadCSV}
            disabled={!file.length || loading}
            loading={loading}
          >
            Submit
          </Button>,
        ]}
        className="upload-csv-modal"
      >
        <Dragger
          disabled={file.length === 2}
          name="file"
          multiple={false}
          maxCount={1}
          accept=".csv, .xlsx"
          {...uploaderProps}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined fill="#000000" />
          </p>
          <p className="ant-upload-text">
            Upload CSV File here.
            <span
              style={{
                textDecoration: "underline",
                color: "#1677ff",
                cursor: "pointer",
              }}
            >
              Browse
            </span>
          </p>
        </Dragger>
        <div style={{ marginTop: "16px", textAlign: "center" }}>
          <Typography.Text>Download template file: </Typography.Text>
          <a
            href="/Rota.xlsx" // Place the sample file in the public folder
            download="employee_rota_template.xlsx"
            style={{
              color: "#1677ff",
              cursor: "pointer",
              textDecoration: "underline",
              marginLeft: "5px",
            }}
          >
            employee_rota_template.xlsx
          </a>
        </div>
      </Modal>
      <Row
        gutter={[16, 16]}
        align="middle"
        justify="space-between"
        style={{ marginBottom: 16 }}
      >
        <Col xs={24} sm={24} md={12} lg={6}>
          <SearchInput
            onSearch={handleSearch}
            placeholder="Search by name or id ..."
            style={{ width: "100%" }}
          />
        </Col>
        {/* <div
          style={{
            width: "50%",
            display: "flex",
            gap: "20px",
          }}
        >
          <Input
            prefix={<SearchOutlined />}
            variant="filled"
            disabled
            style={{
              backgroundColor: "#fff",
            }}
          />

          <Button
            icon={<FilterOutlined />}
            disabled
            style={{
              backgroundColor: "#21218012",
              color: "#324054",
              border: "none",
              borderRadius: "8px",
              padding: "0 16px",
              height: "40px",
            }}
          >
            Filters
          </Button>
        </div> */}
        <Space style={{ flexWrap: "wrap", justifyContent: "flex-end" }}>
          <Button
            style={{
              background: "#212180",
              color: "#fff",
              width: "190px",
              height: "40px",
              padding: "12px 15px",
              margin: "0 10px",
            }}
            onClick={showModal}
            icon={<UploadOutlined />}
          >
            Upload CSV
          </Button>
        </Space>
      </Row>
      <div style={{ background: "#ffffff", borderRadius: "6px" }}>
        <DataTable
          columns={columns}
          rows={rotas?.results || []}
          currentPage={currentPage}
          setCurrentPage={(page) => {
            setCurrentPage(page);
          }}
          position="end"
          marginTop="16px"
          marginBottom="16px"
          pageSize={10}
          totalResults={rotas?.count || 0}
          showSizeChanger={false}
          selectable={true}
          rowKey="id"
          onDeleteSelected={showBulkDeleteConfirm}
          deleteAllText="Delete All Rotas"
          deleteSelectedText="Delete Selected"
          entities="This action will permanently delete the selected rota. Once deleted, this data cannot be recovered."
        />
      </div>
    </>
  );
};

export default React.memo(RotasTableView);